import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { getRouteMeta, SITE_NAME, SITE_URL } from "./routeMeta";

interface SeoProps {
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const Seo = ({ jsonLd }: SeoProps) => {
  const { pathname } = useLocation();
  const meta = getRouteMeta(pathname);
  const clean = pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  const url = `${SITE_URL}${clean === "/" ? "/" : clean}`;

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={meta.type ?? "website"} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
